import React, { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../firebase";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import GoToTop from "../GoToTop";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import loggedin from "./assets/images/loggedin.webp";
import login from "./assets/images/login.gif";

const Login = () => {
  const [user, setUser] = useState(null);

  const navigate = useNavigate();

  // Auth user
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsub();
  }, []);

  const [phone, setPhone] = useState("");

  const [confirmationResult, setConfirmationResult] = useState(null);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [loadingOTP, setLoadingOTP] = useState(false);
  const [loadingVerify, setLoadingVerify] = useState(false);
  const [showOTP, setShowOTP] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);

  const [timer, setTimer] = useState(0);

  const handleChange = (value, index) => {
    // if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move to next box
    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index] === "" && index > 0) {
        document.getElementById(`otp-${index - 1}`).focus();
      }
    }
  };

  // ⏳ Timer countdown
  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  // Setup reCAPTCHA
  const setupRecaptcha = () => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        auth,
        "recaptcha-container",
        {
          size: "invisible",
        },
      );
    }
  };

  // 📩 Send OTP
  const sendOTP = async () => {
    if (!phone) return alert("Enter phone number");

    try {
      setLoadingOTP(true);
      setupRecaptcha();

      const appVerifier = window.recaptchaVerifier;

      // 👉 Ensure +91 is added
      let formattedPhone = phone.trim();

      if (!formattedPhone.startsWith("+91")) {
        formattedPhone = "+91" + formattedPhone;
      }

      const confirmation = await signInWithPhoneNumber(
        auth,
        formattedPhone,
        appVerifier,
      );

      setConfirmationResult(confirmation);
      window.confirmationResult = confirmation;

      setTimer(60); // ⏳ start 60 sec timer

      toast.success("OTP Sent Successfully!");
      setTimeout(() => {
        document.getElementById("otp-0")?.focus();
      }, 100);
    } catch (error) {
      console.error("OTP Error:", error);
    } finally {
      setLoadingOTP(false);
      setShowOTP(false);
    }
  };

  // 🔐 Verify OTP
  const verifyOTP = async () => {
    if (!confirmationResult) {
      toast.error("Please request OTP first");
      return;
    }

    const finalOtp = otp.join("");

    if (finalOtp.length !== 6) {
      toast.error("Enter complete OTP");
      return;
    }

    try {
      setLoadingVerify(true);
      await confirmationResult.confirm(finalOtp);
      toast.success("Login Successful!");
    } catch (error) {
      console.error("Invalid OTP", error);
    } finally {
      setLoadingVerify(false);
    }
  };

  return (
    <>
      <GoToTop />
      <div className="container web-main" style={{ marginTop: "90px" }}>
        <div className="uber-login-wrapper">
          <div className="uber-login-card">
            <img src={login} className="img-fluid mb-2" />

            {!user ? (
              <>
                <h2 className="uberlogin-title">Welcome !!</h2>
                <p className="uber-subtitle">Sign In to <b>DibruGO</b></p>

                {/* Phone Input */}
                {showOTP ? (
                  <>
                    <div className="uber-phone-group">
                      <span className="country-code">+91</span>
                      <input
                        type="tel"
                        placeholder="Enter mobile number"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        className="uber-input"
                      />
                    </div>

                     {/* Send OTP */}
                <button
                  onClick={sendOTP}
                  disabled={loadingOTP || timer > 0}
                  className="uber-btn"
                >
                  {loadingOTP
                    ? "Sending..."
                    : timer > 0
                      ? `Resend in ${timer}s`
                      : "Continue"}
                    </button>
                    
                  </>
                ) : (<><p style={{color:'grey'}}>Logging in as <span>+91 {phone}</span>. <a style={{cursor:'pointer', color:'red'}} onClick={sendOTP}>{timer > 0
                      ? `Resend in ${timer}s`
                      : "Resend"}</a></p></>)}

               

                {/* OTP Section */}
                {confirmationResult && (
                  <>
                    <p className="otp-label">Enter OTP</p>

                    <div className="uber-otp-container">
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          id={`otp-${index}`}
                          type="text"
                          maxLength="1"
                          value={digit}
                          onChange={(e) => handleChange(e.target.value, index)}
                          onKeyDown={(e) => handleKeyDown(e, index)}
                          className="uber-otp-input"
                        />
                      ))}
                    </div>

                    <button
                      onClick={verifyOTP}
                      disabled={loadingVerify}
                      className="uber-btn verify"
                    >
                      {loadingVerify ? "Verifying..." : "Verify & Login"}
                    </button>
                  </>
                )}
              </>
            ) : (
              <>
                <h2 className="uberlogin-title mb-3">You're Logged In</h2>
                <p className="uber-subtitle">{user.phoneNumber}</p>
              </>
            )}
          </div>

          <div id="recaptcha-container"></div>
        </div>
      </div>
    </>
  );
};

export default Login;
